import { RootState } from '../rootReducer';
import { Dialog } from './actions';

export const getDialogState = (state: RootState): Dialog => state.dialog;
